import React, { useState } from "react";
import { IoMdAdd, IoMdClose } from "react-icons/io";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { years } from "../../../functions/YearGenerate";
import InputField from "../../common/form/InputField";
import SelectField from "../../common/form/SelectField";
import { educationDegree } from "../../../mock/DropdownOptions";

const EducationInfo = () => {
  const [educationCount, setEducationCount] = useState(1);

  const addEducation = () => {
    if (educationCount < 10) {
      setEducationCount((prevCount) => prevCount + 1);
    } else {
      toast.error("You can add only up to 10 education entries.");
    }
  };

  const deleteEducation = (index) => {
    const updatedCount = educationCount - 1;
    setEducationCount(updatedCount);
  };

  const renderEducationFields = () => {
    const fields = [];
    for (let i = 1; i <= educationCount; i++) {
      fields.push(
        <div key={i}>
          <div className="flex items-center justify-between mt-5">
            <span className="text-gray-900 mt-5 flex items-center gap-2 cursor-pointer">
              Education {i}
            </span>
            <button
              type="button"
              onClick={() => deleteEducation(i)}
              className="text-red-500 hover:text-red-700"
            >
              <IoMdClose />
            </button>
          </div>
          <div className="mt-5 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div className="sm:col-span-3">
              <SelectField
                selectoptions={educationDegree}
                title={"Education Degree"}
                name={`EducationDegree${i}`}
                required={i === 1}
              />
            </div>
            <div className="sm:col-span-3">
              <InputField
                type="text"
                label="Institute or School"
                name={`EducationalInstitute${i}`}
                required={i === 1}
              />
            </div>
            <div className="sm:col-span-3">
              <InputField
                type="text"
                label="Title or Career"
                name={`EducationTitle${i}`}
                required={i === 1}
              />
            </div>
            <div className="sm:col-span-3">
              <SelectField
                selectoptions={years}
                title={"Finish Year"}
                name={`EducationYear${i}`}
                required={i === 1}
              />
            </div>
          </div>
        </div>
      );
    }
    return fields;
  };

  return (
    <>
      <div className="mt-5">
        <h1 className="text-md font-semibold ">EDUCATIONAL INFO</h1>
        {renderEducationFields()}
        <Link
          type="button"
          onClick={addEducation}
          className="mt-4 mb-4 text-blue-900 flex items-center gap-2 underline font-bold py-2 px-4 rounded w-fit"
        >
          <IoMdAdd /> Add Education
        </Link>
      </div>
    </>
  );
};

export default EducationInfo;
